_getUserPortalSubscriptions